<div class="mc-tab-header__pagination mc-tab-header__pagination_before"
     #previousPaginator
     [class.mc-disabled]="disableScrollBefore"
     (click)="handlePaginatorClick('before')"
     (mousedown)="handlePaginatorPress('before', $event)"
     (touchend)="stopInterval()">

    <i mc-icon="mc-angle-left-M_16"></i>
</div>

<div class="mc-tab-header__content"
     #tabListContainer
     (keydown)="handleKeydown($event)">

    <div class="mc-tab-list"
         #tabList
         (cdkObserveContent)="onContentChanges()">
        <div class="mc-tab-list__content">
            <ng-content></ng-content>
        </div>
    </div>
</div>

<div class="mc-tab-header__pagination mc-tab-header__pagination_after"
     #nextPaginator
     [class.mc-disabled]="disableScrollAfter"
     (mousedown)="handlePaginatorPress('after', $event)"
     (click)="handlePaginatorClick('after')"
     (touchend)="stopInterval()">

    <i mc-icon="mc-angle-right-M_16"></i>
</div>
